var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.25289 1.67102C6.25289 1.67102 1.25294 5.35347 1.25293 6.67106C1.25292 7.98865 6.25293 11.671 6.25293 11.671",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackarrow);
export default __webpack_public_path__ + "static/media/back arrow.c57e2bffe09a897871a42d81aeb6eb21.svg";
export { ForwardRef as ReactComponent };